__turbopack_context__.v({
  "body": "CartDrawer-module__egdiMG__body",
  "emptyState": "CartDrawer-module__egdiMG__emptyState",
  "footer": "CartDrawer-module__egdiMG__footer",
  "line": "CartDrawer-module__egdiMG__line",
  "lineActions": "CartDrawer-module__egdiMG__lineActions",
  "lineDetails": "CartDrawer-module__egdiMG__lineDetails",
  "linePrice": "CartDrawer-module__egdiMG__linePrice",
  "lineTitle": "CartDrawer-module__egdiMG__lineTitle",
  "lineVariant": "CartDrawer-module__egdiMG__lineVariant",
  "lines": "CartDrawer-module__egdiMG__lines",
  "thumb": "CartDrawer-module__egdiMG__thumb",
  "thumbPlaceholder": "CartDrawer-module__egdiMG__thumbPlaceholder",
  "totals": "CartDrawer-module__egdiMG__totals",
  "unavailableNotice": "CartDrawer-module__egdiMG__unavailableNotice",
});
